import React, { ReactNode } from 'react'

import { IconBox, Stat, StatCardWrapper, Sup, Text } from './statCard.styles'

export interface StatCardProps {
  variant: 'Speed' | 'Accuracy' | 'Duration' | 'uppercase' | 'lowercase' | 'number' | 'symbols'
  icon: ReactNode
  avg?: number
  testNumber?: number
}

export const StatCard = (props: StatCardProps) => {
  const { variant, icon, avg = 0, testNumber } = props

  return (
    <StatCardWrapper>
      <IconBox variant={variant}>{icon}</IconBox>
      <Text>{variant}</Text>
      <Stat>
        {variant === 'Duration' ? avg?.toFixed(2) : avg?.toFixed()}
        <Sup>
          {variant === 'Speed' && 'wpm'}
          {variant === 'Accuracy' && '%'}
          {variant === 'Duration' && 'min'}
        </Sup>
      </Stat>
      <Stat left={true}>
        {testNumber || 0}
        <Sup>test{testNumber === 1 ? '' : 's'}</Sup>
      </Stat>
    </StatCardWrapper>
  )
}
